// Roles the app understands. Anything else the server reports is ignored, and
// a user with none of them is treated as a plain user — the same fallback
// backend/auth.py applies, so the menu and the API agree.
export const ROLE_ADMIN = "admin";
export const ROLE_USER = "user";
export const KNOWN_ROLES = [ROLE_ADMIN, ROLE_USER];
export const DEFAULT_ROLE = ROLE_USER;
